import { createSlice } from '@reduxjs/toolkit';

export enum Media {
  SELECT = 'SELECT',
  REVIEW = 'REVIEW',
  UPLOAD = 'UPLOAD',
  CONFIRMATION = 'CONFIRMATION',
}

export const STEPS = [
  Media.SELECT,
  Media.REVIEW,
  Media.UPLOAD,
  Media.CONFIRMATION,
] as const;

interface StepState {
  currentStep: Media;
}

const initialState: StepState = {
  currentStep: Media.SELECT,
};

export const stepSlice = createSlice({
  name: 'step',
  initialState,
  reducers: {
    nextStep: (state) => {
      const currentIndex = STEPS.indexOf(state.currentStep);
      if (currentIndex < STEPS.length - 1) {
        state.currentStep = STEPS[currentIndex + 1];
      }
    },
    previousStep: (state) => {
      const currentIndex = STEPS.indexOf(state.currentStep);
      if (currentIndex > 0) {
        state.currentStep = STEPS[currentIndex - 1];
      }
    },
    reset: (state) => {
      state.currentStep = Media.SELECT;
    },
    retry: (state) => {
      state.currentStep = Media.REVIEW;
    }
  },
});

export const { nextStep, previousStep, reset, retry } = stepSlice.actions;
export default stepSlice.reducer;
